// extracted by mini-css-extract-plugin
module.exports = {"selectboxFilterWrapper":"SeverityFilter_selectboxFilterWrapper__2pBqm"};